import { IStatistics } from '../../types';
import { StatsAction, statsAcionType } from '../type';

interface IUserStatistics {
  userStats: IStatistics | null;
}
const initialState: IUserStatistics = {
  userStats: null,
};
export const statsReducer = (state = initialState, action: StatsAction) => {
  switch (action.type) {
    case statsAcionType.UPDATE_USER_STATS:
      return {
        ...state,
      };
    case statsAcionType.UPDATE_USER_STATS_SUCCESS:
      return {
        ...state,
        userStats: action.payload,
      };
    default:
      return state;
  }
};
